import { render, staticRenderFns } from "./Recipe_card.vue?vue&type=template&id=a96ae2ee&scoped=true&"
import script from "./Recipe_card.vue?vue&type=script&lang=js&"
export * from "./Recipe_card.vue?vue&type=script&lang=js&"
import style0 from "./Recipe_card.vue?vue&type=style&index=0&id=a96ae2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96ae2ee",
  null
  
)

export default component.exports